import React from 'react';
import PrivacyStatement from './privacy-statement';

export default () => <PrivacyStatement language="nl" />;
